<template>
  <div>
    <iframe
      v-if="turnOnSound"
      src="https://s3.amazonaws.com/images.growmindgrow/250-milliseconds-of-silence.mp3"
      allow="autoplay"
      style="display:none"
    >
    </iframe>
    <audio
      v-if="turnOnSound"
      src="https://s3.amazonaws.com/images.growmindgrow/KidsClapWhistle.mp3"
      preload="auto"
      autoplay
      loop
    >
    </audio>
  </div>
</template>

<script>
export default {
  name: 'TransitionMusic',
  computed: {
    turnOnSound() {
      return this.$store.getters.getSoundOn;
    },
  },
};
</script>

<style scoped>

</style>
